import { createRef } from 'react'

import { SignInData } from '~services'
import { SignUpFormValues } from '~types/authForms'
import createGenericContext from '~utils/createGenericContext'
import { asyncNoop } from '~utils/noop'

// TODO: modify return options from signIn, signOut, signUp and add sendPasswordResetEmail and confirmPasswordReset functions
export type AuthContextType = {
  isSignedIn: boolean | null
  profileUpdated: boolean
  signIn: (data: SignInData) => Promise<void>
  signInWithOtp: (data: Pick<SignInData, 'email'>) => Promise<void>
  signOut: () => void
  signUp: (data: SignUpFormValues) => Promise<void>
}

export const [useAuthContext, AuthContextProvider] =
  createGenericContext<AuthContextType>('AuthContext')

const initialState: AuthContextType = {
  isSignedIn: null,
  profileUpdated: false,
  signIn: asyncNoop,
  signInWithOtp: asyncNoop,
  signOut: asyncNoop,
  signUp: asyncNoop,
}

export const authContextRef = createRef<AuthContextType>()

// @ts-expect-error: wrong interface of react createRef()
authContextRef.current = initialState
